import React from 'react';
import Result from './Result';

export default React.createClass({
    propTypes: {
        urls: React.PropTypes.object,
        i18n: React.PropTypes.object,
        profilePhotoPlaceholderUrl: React.PropTypes.string
    },
    getInitialState() {
        return {
            data: null,
            loading: false,
            error: false
        };
    },
    componentWillMount() {
        this.getUsers = function(query) {
            if (query !== '') {
                this.serverRequest = $.get(this.props.urls.get, {
                    searchTerm: query
                }, (result) => {
                    if (result.Error) {
                        this.setState({
                            loading: false,
                            error: true
                        });
                    } else {
                        console.log('searchFriend: ', result);
                        this.setState({
                            loading: false,
                            data: result
                        });
                        dataLayer.push({
                            'event': 'search_friend',
                            'searchterm': query,
                            'eventCategory': 'friends',
                            'eventAction': 'search',
                            'eventLabel': "",
                        }); 
                    }
                }).fail(() => {
                    this.setState({
                        loading: false,
                        error: true
                    });
                });
            } else {
                this.setState({
                    loading: false,
                    error: false,
                    data: []
                });
            }
        };

        this.handleKeyUpDebounced = _.debounce(this.getUsers, 700);
    },
    componentWillUnmount: function() {
        this.serverRequest.abort();
        this.handleKeyUpDebounced.cancel();
    },
    handleKeyUp() {
        // Show loader when user submits query
        this.setState({
            loading: true
        });

        this.handleKeyUpDebounced(this.refs.input.value);
    },
    handleSubmit() {
        // Show loader when user submits query
        this.setState({
            loading: true
        });

        this.getUsers(this.refs.input.value);
    },
    render() {
        const buttonLoadingClass = (this.state.loading) ? 'is-loading' : '';

        return (
            <div className="c-linkBlockGroup">
                <div className="c-module c-module--noshadow c-friends__search">
                    <div className="c-form__input c-friends__search__input">
                        <input ref="input" type="text" placeholder={this.props.i18n.inputPlaceholder} onKeyUp={this.handleKeyUp} />
                    </div>
                    <button type="submit" className={`c-button c-friends__search__button ${buttonLoadingClass}`} disabled={this.state.loading ? 'disabled' : ''} onClick={this.handleSubmit}>
                        <span>{this.props.i18n.searchButton}</span>
                    </button>
                </div>
                <Result
                    loading={this.state.loading}
                    error={this.state.error}
                    data={this.state.data}
                    urls={this.props.urls}
                    i18n={this.props.i18n}
                    profilePhotoPlaceholderUrl={this.props.profilePhotoPlaceholderUrl}
                />
            </div>
        );
    }
});
